<template>
  <div class="order-detail qm-page-bg">
    <van-nav-bar title="订单详情" left-arrow class="qm-nav-bar" @click-left="goHome" />

    <div class="content" v-if="order">
      <div class="status-card qm-glass-card">
        <div class="status-title">下单成功</div>
        <div class="wait-no" v-if="pickNo">取餐号 {{ pickNo }}</div>
        <div class="sub">请到店出示取餐信息</div>
      </div>

      <div class="info-card qm-glass-card">
        <div class="row">
          <span class="label">门店</span>
          <span class="value">{{ order.storeName || order.shopName || '-' }}</span>
        </div>
        <div class="row">
          <span class="label">商品</span>
          <span class="value">{{ order.productName }} {{ order.skuName }}</span>
        </div>
        <div class="row">
          <span class="label">优惠券</span>
          <span class="value">{{ order.couponName || '-' }}</span>
        </div>
        <div class="row">
          <span class="label">订单号</span>
          <span class="value mono">{{ order.orderId }}</span>
        </div>
        <div class="row">
          <span class="label">实付</span>
          <span class="value price">¥{{ fenToYuan(order.total || 0) }}</span>
        </div>
      </div>

      <van-button
        v-if="order.payUrl && Number(order.total) > 0"
        type="primary"
        block
        class="qm-btn-primary pay-btn"
        @click="openPay"
      >
        去支付
      </van-button>

      <van-button plain block class="refresh-btn" :loading="refreshing" @click="refreshStatus">
        刷新取餐号
      </van-button>
    </div>

    <van-empty v-else description="暂无订单" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import request from "@/utils/request";
import { fenToYuan } from "@/utils/tims";

export default {
  name: "OrderDetail",
  data() {
    return {
      order: null,
      refreshing: false,
      pickNo: "",
    };
  },
  computed: {
    ...mapState(["uuid", "lastOrder"]),
  },
  created() {
    this.order = this.lastOrder || null;
    if (this.order) {
      this.pickNo =
        (this.order.waitNo && (this.order.waitNo.pickNo || this.order.waitNo.waitNo)) ||
        (this.order.order && this.order.order.pickNo) ||
        "";
    }
    const orderNo = this.$route.query.orderNo;
    if (orderNo && this.uuid) {
      this.refreshStatus();
    }
  },
  methods: {
    fenToYuan,
    goHome() {
      this.$router.replace("/cardkey");
    },
    openPay() {
      if (this.order && this.order.payUrl) {
        window.location.href = this.order.payUrl;
      }
    },
    async refreshStatus() {
      const orderId = (this.order && this.order.orderId) || this.$route.query.orderNo;
      if (!this.uuid || !orderId) return;
      this.refreshing = true;
      try {
        const resp = await request.post("/tims/order-status", {
          uuid: this.uuid,
          orderId,
        });
        const data = resp.data || {};
        this.pickNo = data.pickNo || data.waitNo || this.pickNo;
        if (!this.pickNo && data.data) {
          this.pickNo = data.data.pickNo || data.data.waitNo || "";
        }
        this.$toast(this.pickNo ? `取餐号 ${this.pickNo}` : "已刷新");
      } catch (e) {
        this.$toast.fail(e.message || "刷新失败");
      } finally {
        this.refreshing = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  min-height: 100vh;
}

.content {
  padding: 16px;
}

.status-card {
  text-align: center;
  padding: 28px 16px;
  margin-bottom: 12px;

  .status-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .wait-no {
    font-size: 32px;
    font-weight: 800;
    color: #c8102e;
    letter-spacing: 2px;
    margin: 8px 0;
  }

  .sub {
    font-size: 13px;
    color: #999;
  }
}

.info-card {
  padding: 8px 16px;
  margin-bottom: 16px;

  .row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid #f2f2f2;
    font-size: 14px;

    &:last-child {
      border-bottom: none;
    }

    .label {
      color: #999;
      flex-shrink: 0;
    }

    .value {
      text-align: right;
      color: #333;
      word-break: break-all;
    }

    .mono {
      font-family: ui-monospace, monospace;
      font-size: 12px;
    }

    .price {
      color: #c8102e;
      font-weight: 700;
    }
  }
}

.pay-btn {
  margin-bottom: 10px;
}

.refresh-btn {
  margin-bottom: 20px;
}
</style>
